module.exports = __webpack_public_path__ + "img/logo3.7454b1d3.png";